<div class="unauthorized">
  <div class="unauthorized__content">
      <h1>401</h1>
      <p>
          Du har ikke adgang til denne side, kontakt din administrator for yderligere information.
      </p>
      <p>Gå tilbage til <a routerLink="/">forsiden.</a></p>
  </div>
</div>
